import React, { FC, useContext, Suspense } from 'react';
import Blade from '../Blade';
import { Loader } from '../Loader';
import { ExperimentsContext } from '../../context/ExperimentsContext';
// import { RequestAValuationForm } from './RequestAValuationForm';

const RequestAValuationForm = React.lazy(() => import('./RequestAValuationForm'));
const TestKFH23002ValuationForm = React.lazy(() => import('./TestKFH23002ValuationForm'));
interface RequestAValuationBladeProps {
  enquiryType?: 'Sales' | 'Lettings';
}

export const RequestAValuationBlade: FC<RequestAValuationBladeProps> = ({ enquiryType }) => {
  const { experiments } = useContext(ExperimentsContext);
  return (
    <Blade width="narrow" id="propertyRequestAValuation" customBlade>
      <Suspense fallback={<Loader size="small" />}>
        {experiments?.KFH23002 === 'variation' ? (
          <TestKFH23002ValuationForm enquiryType={enquiryType} />
        ) : (
          <RequestAValuationForm enquiryType={enquiryType} />
        )}
      </Suspense>
    </Blade>
  );
};

export default RequestAValuationBlade;
